import { getFullUrl } from 'hubspot-url-utils';
import { useTranslation } from '../../../../hooks/useNavConfig';
import { AccountExtraLink } from '../AccountExtrasLink';
import { selectHubspotCredits } from './selectors';
import { useAppSelector } from '../../../../hooks/redux';
import { jsx as _jsx } from "react/jsx-runtime";
const HubSpotCreditsLink = ({
  portalId
}) => {
  const {
    t
  } = useTranslation();
  const {
    totalCredits,
    creditsUsed,
    isEnabled
  } = useAppSelector(selectHubspotCredits);
  const creditsRemaining = totalCredits - creditsUsed;
  const creditDisplayText = creditsRemaining <= 0 ? t('nav.account.credits.noCredits') : t('nav.account.credits.count', {
    count: String(creditsRemaining),
    total: String(totalCredits)
  });
  if (!isEnabled) {
    return null;
  }
  return /*#__PURE__*/_jsx(AccountExtraLink, {
    id: "hubspotCredits",
    link: `${getFullUrl('app')}/account-and-billing/${portalId}/usage/hubspot-credits`,
    linkText: t('nav.account.credits.title'),
    secondaryText: creditDisplayText,
    isNewItem: true
  });
};
export default HubSpotCreditsLink;